import { getResData, httpClient } from "utils";
import {
  DataProvider,
  InterExtrapolateRequestBody,
  ReminderCollector,
  ReminderFormDataRequest,
  ReminderRecipient,
  SendReminderRequest,
} from "./types";
import {
  INTEREXTRAPOLATE_API_PATHS,
  MISSING_DOCUMENTS_API_PATHS,
  MISSING_DOCUMENTS_REMINDER_API_PATHS,
} from "./consts";

export interface ReminderFormDataResponse {
  collectors: ReminderCollector[];
  recipients: ReminderRecipient[];
  dataProviders?: DataProvider[];
}

export const postMissingDocuments = (missingDocumentsRequest: any) =>
  httpClient.post<any>(
    MISSING_DOCUMENTS_API_PATHS.MISSING_DOCUMENTS,
    missingDocumentsRequest,
  );

export const postMissingDocumentsExport = (body: any) =>
  httpClient
    .post(MISSING_DOCUMENTS_API_PATHS.MISSING_DOCUMENTS_EXPORT, body, {
      responseType: "arraybuffer",
    })
    .then(getResData);

export const interExtrapolateFillGaps = (body: InterExtrapolateRequestBody) =>
  httpClient.post(INTEREXTRAPOLATE_API_PATHS.FILL_GAPS, body);

export const interExtrapolateRefresh = (body: InterExtrapolateRequestBody) =>
  httpClient.post(INTEREXTRAPOLATE_API_PATHS.REFRESH_EXTRAPOLATION, body);

export const postReminderFormData = (body: ReminderFormDataRequest) =>
  httpClient
    .post<ReminderFormDataResponse>(
      MISSING_DOCUMENTS_REMINDER_API_PATHS.FORM_DATA,
      body,
    )
    .then(getResData);

export const postSendReminder = (body: SendReminderRequest) =>
  httpClient.post(MISSING_DOCUMENTS_REMINDER_API_PATHS.SEND, body);
